export function getModalStyles(props) {
    var theme = props.theme;
    var effects = theme.effects;
    var styles = {
        main: {
            borderRadius: effects.roundedCorner8,
            boxShadow: effects.elevation64,
        },
    };
    return styles;
}
//# sourceMappingURL=Modal.styles.js.map